<!--
 @description 作业平台---新增、编辑页
 @author xiehan
 @date 2018/10/23
-->
<template>
  <div class="handlerPlatform  hanlerPlatform__content">
    <g-back :history="history" class="ilb mr-base" @back="showHostList = false"></g-back>
    <el-button
      type="danger"
      @click="deletePlatform"
      v-g-rac="gRac('handlerPlatform@delete') && isEdit"
      v-text="$t('common.delete')"></el-button>
    <el-form ref="platForm" :model="platForm" label-width="76px" :inline="true" :rules="rules">
      <div class="code-editor-wrap">
        <codemirror
          v-model="platForm.content"
          :options="editorOptions"
          @change="onEditorContentChange">
        </codemirror>
      </div>
      <div>
        <el-form-item :label="$t('platform.fileName')" prop="fileName">
          <el-input v-model="platForm.fileName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('platform.type')" prop="type" label-width="40px">
          <g-select :list="select_command" v-model="platForm.type"></g-select>
        </el-form-item>
        <el-form-item :label="$t('platform.fileFormat')" prop="fileFormat">
          <g-select :list="select_format" v-model="platForm.fileFormat"></g-select>
        </el-form-item>
      </div>
      <div>
        <el-form-item :label="$t('platform.machines')" prop="machines" input-width="auto">
          <el-input v-model="inputIPList" @input="inputIPChange" type="textarea"
            style="width: 282px;" :placeholder="$t('clusterManager.ipTips')"></el-input>
          <el-button type="primary" @click="showHostList = !showHostList" v-text="hostListBtnText"></el-button>
          <el-collapse-transition>
            <div v-show="showHostList">
              <label style="color: rgba(0, 0, 0, 0.65);">{{ $t('appManager.belongingGroup') }}</label>
              <el-cascader v-model="selectGroup" :options="options" clearable @change="selectGroupChange"></el-cascader>
              <el-transfer 
                ref="transferForm"
                v-model="platForm.machines" 
                :data="hostList" 
                filterable 
                :filter-method="filterHost"
                :titles="hostTitle"
                @change="hostChange"></el-transfer>
            </div>
          </el-collapse-transition>
        </el-form-item>
      </div>
      <div>
        <el-form-item :label="$t('platform.scriptType')" prop="scriptType">
          <g-select :list="select_format" v-model="platForm.scriptType"></g-select>
        </el-form-item>
      </div>
      <div class="code-editor-wrap script-editor-wrap">
        <codemirror
          v-model="platForm.script"
          :options="editorOptions"
          @change="onEditorScriptChange">
        </codemirror>
      </div>
      <div>
        <el-form-item :label="$t('platform.explain')" prop="explain" input-width="716px">
          <el-input
            type="textarea"
            :rows="4"
            v-model="platForm.explain">
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-button type="primary" class="loading-btn" :loading="true" v-show="showLoading"></el-button>
    <div v-show="excuteResult.length > 0 && !showLoading" class="execute-result-wrap">
      <span v-text="$t('platform.executeResult')"></span>
      <span v-text="$t('platform.check')" class="choose-btn" @click="dialogVisible = true"></span>
    </div>
    <el-button
      type="primary"
      @click="save"
      style="margin-left: 76px;"
      v-g-rac="gRac('handlerPlatform@save')" 
      v-text="$t('common.save')"></el-button>
    <el-button 
      type="primary" 
      class="ml-base"
      @click="execute"
      v-g-rac="gRac('handlerPlatform@execute')" 
      v-text="$t('platform.execute')"></el-button>
      <el-dialog :closeOnClickModal="false"
        :title="$t('platform.executeResult')"
        :visible.sync="dialogVisible"
        width="600px">
        <div class="logs-wrap">
          <div v-for="(item, index) in excuteResult" :key="'result'+index" v-text="item"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" v-text="$t('common.close')"></el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import codemirror from '@/components/codemirror.vue'

  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import platformBiz from '@/logic/continuousDelivery/platformBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        inputIPList: '',
        selectGroup: [],
        options: [],
        isEdit: false,
        editorOptions: {
          tabSize: 2,
          styleActiveLine: false,
          lineNumbers: true,
          line: true,
          theme: 'idea',
          foldGutter: true,
          styleSelectedText: true,
          gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
          mode: 'text/x-sh',
          // 快捷键 可提供三种模式 sublime、emacs、vim
          //                    keyMap: "sublime",
          matchBrackets: true,
          showCursorWhenSelecting: true
        },
        platForm: {
          fileName: '',
          type: '',
          fileFormat: '',
          scriptType: '',
          explain: '',
          content: '',
          script: '',
          machines: []
        },
        rules: {
          fileName: [
            { required: true, message: this.$t('common.entryTips') + this.$t('platform.fileName'), trigger: 'blur' }
          ]
        },
        select_command: {},
        select_format: {},
        showHostList: false,
        hostList: [],
        hostListBtnText: this.$t('platform.open'),
        hostTitle: [],
        filterHost (query, item) {
          return String(item['key']).indexOf(query) > -1
        },
        showLoading: false,
        logTimer: null,
        excuteResult: [],
        dialogVisible: false
      }
    },
    methods: {
      init () {
        this.isEdit = !!this.$route.query.id
        this.waitCommand()
        this.waitFormat()
        this.getHostList()
        this.setHistory()
        this.getSiteList()
        if (this.isEdit) {
          platformBiz.getPlatformById({ id: this.$route.query.id }).then((data) => {
            for (let i in this.platForm) {
              this.platForm[i] = data[i]
            }
            this.inputIPList = this.platForm.machines.join(',')
          })
        } else {
          this.resetForm()
        }
      },
      transToCascader(str) {
        return {
          value: str,
          label: str
        }
      },
      setHistory () {
        this.history = []
        this.history.push({
          name: this.isEdit ? this.$t('platform.editPlatform') : this.$t('platform.addPlatform')
        })
      },
      getSiteList () {
        cmdbBiz.getAllSiteGroup().then(data => {
          let siteList = []
          data.map(item => {
            let groupList = []
            if (item.groups) {
              item.groups.map(groupsItem => {
                groupList.push(this.transToCascader(groupsItem))
              })
            }
            siteList.push({ ...this.transToCascader(item.siteCode), children: groupList })
          })
          this.options = siteList
        })
      },
      async waitCommand () {
        await this.dGetDictionaryByCode('commandType')
        this.select_command = { ...this.dDictionary.commandType }
        this.platForm.type = Object.keys(this.select_command)[0]
      },
      async waitFormat () {
        await this.dGetDictionaryByCode('formatType')
        this.select_format = { ...this.dDictionary.formatType }
        this.platForm.fileFormat = Object.keys(this.select_format)[0]
        this.platForm.scriptType = Object.keys(this.select_format)[0]
      },
      getHostList (obj) {
        cmdbBiz.hostList({ perPageCount: 99999, ...obj }).then((data) => {
          if (data && data.dataList) {
            let arr = []
            data.dataList.map(item => {
              let obj = { key: item.ip1, label: item.ip1 }
              arr.push(obj)
            })
            this.hostList = arr
          }
        })
      },
      deletePlatform () {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          platformBiz.deletePlatform({ id: this.$route.query.id }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.$router.push({ name: 'platform' })
          })
        }).catch(() => {})
      },
      onEditorContentChange (val) {
        this.platForm.content = val
      },
      onEditorScriptChange (val) {
        this.platForm.script = val
      },
      selectGroupChange(val) {
        this.getHostList({
          siteCode: val[0],
          group: val[1]
        })
      },
      testIpList(ips) {
        return !!!ips.length || ips.split(',')
          .every(ip => {
            const segments = ip.split('.');
            return segments.length === 4
              && segments
                .map(segment => parseInt(segment, 10))
                  .every(n => n >= 0 && n <= 255);
          });
      },
      inputIPChange (val) {
        const isInputRight = this.testIpList(val)
        if (isInputRight) {
          this.platForm.machines = []
          val.split(',').map((item) => {
            if (this.hostList.some(hostItem => hostItem.key === item)) this.platForm.machines.push(item)
          })
        } else {}
      },
      hostChange (val) {
        const ipList = val
        this.inputIPList = ipList.join(',')
      },
      save () {
        if (!this.platForm.content) {
          this.$message({
            message: this.$t('platform.connectTips'),
            type: 'warning'
          })
          return
        }
        this.$refs['platForm'].validate((valid) => {
          if (valid) {
            let saveObj = { ...this.platForm }
            if (this.isEdit) saveObj['id'] = this.$route.query.id
            platformBiz.savePlatform(saveObj).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.showHostList = false
              this.$router.push({ name: 'platform' })
            })
          } else {
            return false
          }
        })
      },
      getLog (num) {
        clearTimeout(this.logTimer)
        this.logTimer = null
        platformBiz.getPlatformLog({ pointer: num }).then((d) => {
          if (d.logs.length > 0) {
            d.logs.map((item) => {
              this.excuteResult.push(item)
            })
            this.logTimer = setTimeout(() => {
              this.getLog(d.pointer)
            }, 1500)
          } else {
            this.showLoading = false
          }
        })
      },
      execute () {
        if (!this.platForm.content) {
          this.$message({
            message: this.$t('platform.connectTips'),
            type: 'warning'
          })
          return
        }
        this.$refs['platForm'].validate((valid) => {
          if (valid) {
            this.showLoading = true
            this.excuteResult = []
            platformBiz.excutePlatform(this.platForm).then((d) => {
              setTimeout(() => {
                this.getLog(0)
              }, 1500)
            })
          } else {
            return false
          }
        })
      },
      resetForm () {
        this.$refs.platForm.resetFields()
        this.inputIPList = ''
        this.platForm.script = ''
        this.platForm.content = ''
      }
    },
    watch: {
      showHostList (val) {
        this.hostTitle = [this.$t('platform.hostList'), this.$t('platform.choosen')]
        this.hostListBtnText = val ? this.$t('platform.hide') : this.$t('platform.open')
      },
      $route (to, from) {
        if (to.name === 'handlerPlatform' && from.name === 'platform') {
          this.init()
        }
      }
    },
    components: {
      codemirror
    },
    mounted () {
      this.init()
    }
  }
</script>

<style>
  .handlerPlatform .code-editor-wrap {
    width: 796px;
    margin-bottom: 16px;
  }
  .handlerPlatform .script-editor-wrap .CodeMirror {
    height: 200px;
  }
  .handlerPlatform .code-editor-wrap .CodeMirror {
    background: #e7e9db;
  }
  .handlerPlatform .code-editor-wrap .CodeMirror-gutters {
    background: #e7e9db;
  }
  .handlerPlatform .loading-btn {
    margin-left: 70px;
    color: #000;
    background: #fff;
    border: none;
    font-size: 20px;
    display: block;
  }
  .handlerPlatform  .choose-btn {
    color: #3385ff;
    cursor: pointer;
  }
  .handlerPlatform .execute-result-wrap{
    font-size: 14px;
    margin: 0 0 10px 76px;
  }
  .handlerPlatform .logs-wrap {
    max-height: 300px;
    overflow-y: auto;
  }
</style>